import React from 'react';

interface EmptyStateProps {
  error: string | null;
  searchQuery: string;
  currentPrefix: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({ error, searchQuery, currentPrefix }) => {
  const renderEmptyContent = () => {
    if (error === 'DIRECTORY_NOT_FOUND') {
      return (
        <>
          <div className="w-24 h-24 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <svg className="w-12 h-12 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2-2z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 16L15 10M9 10l6 6" />
            </svg>
          </div>
          <h3 className="text-xl font-semibold mb-3" style={{ color: '#4B5563' }}>Directory Not Found</h3>
          <p style={{ color: '#6B7280' }} className="max-w-md mx-auto">The directory you're looking for doesn't exist at this location.</p>
        </>
      );
    }
    
    if (error === 'FILE_PREFIX_NOT_FOUND') {
      return (
        <>
          <div className="w-24 h-24 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <svg className="w-12 h-12 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 16L15 10M9 10l6 6" />
            </svg>
          </div>
          <h3 className="text-xl font-semibold mb-3" style={{ color: '#4B5563' }}>No Items Found</h3>
          <p style={{ color: '#6B7280' }} className="max-w-md mx-auto">
            No files or folders containing "{currentPrefix.split('/').pop()}" found in this location.
          </p>
        </>
      );
    }
    
    if (searchQuery) {
      return (
        <>
          <div className="w-24 h-24 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <svg className="w-12 h-12 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </div>
          <h3 className="text-xl font-semibold mb-3" style={{ color: '#4B5563' }}>No matches found</h3>
          <p style={{ color: '#6B7280' }} className="max-w-md mx-auto">
            No items in this folder match "{searchQuery}". Try a different search term.
          </p>
        </>
      );
    }
    
    return (
      <>
        <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg className="w-12 h-12 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2-2z" />
          </svg>
        </div>
        <h3 className="text-xl font-semibold mb-3" style={{ color: '#4B5563' }}>This folder is empty</h3>
        <p style={{ color: '#6B7280' }} className="max-w-md mx-auto">There are no files or folders in this directory. Try navigating to a different location or check back later.</p>
      </>
    );
  };

  return (
    <div className="flex-1 flex items-center justify-center">
      <div className="text-center">
        {renderEmptyContent()}
      </div>
    </div>
  );
};

export default EmptyState;
